import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useEffectiveRole } from '@/composables/useEffectiveRole'

/**
 * Guards license purchase and payment management actions.
 *
 * Allowed for:
 *   - partner level users (always)
 *   - restaurant_company users whose company has no partner or a Flixorder partner
 *
 * Listing is not gated by this — only mutative actions (buy, add/edit/delete payment) use this.
 */
export const useLicensePurchaseAccess = () => {
  const authStore = useAuthStore()
  const { effectiveRole } = useEffectiveRole()

  const canPurchaseLicense = computed(() => {
    if (effectiveRole.value === 'partner') return true
    if (effectiveRole.value === 'restaurant_company') {
      const partnerName = authStore.user?.partnerName
      const isFlixorderPartner = !partnerName || partnerName.toLowerCase().includes('flixorder')
      return isFlixorderPartner
    }
    return false
  })

  return { canPurchaseLicense }
}
